import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx-js-style';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-employee-monthly-salary',
  templateUrl: './employee-monthly-salary.component.html',
  styleUrls: ['./employee-monthly-salary.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule,],
  providers: [DatePipe],
})
export class EmployeeMonthlySalaryComponent implements OnInit {
  public showSpinner = false;
  public selected_date: any = [];
  public usersList: any = [];
  public totalSalary: any = [];
  public total_shourtHours: any = [];
  public total_lateCheckin: any = [];
  public total_unpaidLeaves: any = [];
  public total__absents: any = [];
  public total_Advance: any = [];
  public total_Overtime: any = [];
  public total_tax: any = [];
  public loan_amount: any = [];
  public total_otherDeduction: any = [];
  public total_Compensation: any = [];
  public totalDeduction: any = [];
  public totalReleasedSalary: any = [];
  public month_char!: string | null;
  public month_year!: number | null;
  public month_int!: number | null;
  fileName = 'KodexSalarySheet.xlsx';
  user: any;
  selectedMode: any;
  datamode: any;
  userInfo: any;
  colormode: any;
  constructor(
    public datepipe: DatePipe,
    public router: Router,
    public activated_route: ActivatedRoute,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type != "Admin" && user_role.role_type != "Admin_AND_Team_Lead") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.selected_date = this.activated_route.snapshot.paramMap.get('selected_date')
    const date = new Date(this.selected_date);
    this.month_char = this.datepipe.transform(date, "MMMM")
    this.month_year = date.getFullYear()
    this.month_int = date.getMonth() + 1
    this.getData(this.month_char ?? "", this.month_year, this.month_int)
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  exportexcelsheet() {
    this.fileName = 'Salary_Sheet' + '_' + this.month_char + '_' + this.month_year + '.xlsx';
    /* table id is passed over here */
    const element = document.getElementById('excel-table1');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    // Define column widths for specific columns
    const wscols = [
      { wch: 20 }, { wch: 20 }, { wch: 15 },
    ];

    // Set column widths for the worksheet
    ws['!cols'] = wscols;

    // Set row heights for all rows
    const range = XLSX.utils.decode_range(ws['!ref'] as string);
    const wsRows = [];
    for (let i = 0; i <= range.e.r; i++) {
      wsRows.push({ hpt: 40 });
    }
    ws['!rows'] = wsRows;

    // Apply cell styling
    for (let r = range.s.r; r <= range.e.r; r++) {
      for (let c = range.s.c; c <= range.e.c; c++) {
        const cellAddress = XLSX.utils.encode_cell({ r: r, c: c });
        if (!ws[cellAddress]) continue;

        // Default cell styling
        ws[cellAddress].s = {
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          font: { sz: 10 },
          border: {
            top: { style: 'thin', color: { rgb: '488dd1' } },
            bottom: { style: 'thin', color: { rgb: '488dd1' } },
            left: { style: 'thin', color: { rgb: '488dd1' } },
            right: { style: 'thin', color: { rgb: '488dd1' } }
          }
        };

        // Apply specific cell styling based on row and column indices
        if (r === 0) {
          // First two header rows: Blue background with white text
          ws[cellAddress].s.fill = { fgColor: { rgb: '112A5F' } };
          ws[cellAddress].s.font = { color: { rgb: 'FFFFFF' } };
        }
        else if (r === range.e.r) {
          ws[cellAddress].s.fill = { fgColor: { rgb: '112A5F' } };
          ws[cellAddress].s.font = { color: { rgb: 'FFFFFF' } };
        }

        else if (c === 2) {
          // Column C: Pink background
          ws[cellAddress].s.fill = { fgColor: { rgb: 'FAD3D0' } };
        } else {
          // Default cell styling for other cells
          ws[cellAddress].s.fill = { fgColor: { rgb: 'E7EBF4' } };
        }
      }
    }



    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Salary');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);

  }

  exportexcel() {
    this.fileName = `Full_Salary_Sheet_${this.month_char}_${this.month_year}.xlsx`;

    // Get the HTML table element by its ID
    const element = document.getElementById('excel-table');

    // Convert the HTML table element to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    // Define column widths for specific columns
    const wscols = [
      { wch: 20 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
      { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 14 }, { wch: 14 },
    ];

    // Set column widths for the worksheet
    ws['!cols'] = wscols;

    // Set row heights for all rows
    const range = XLSX.utils.decode_range(ws['!ref'] as string);
    const wsRows = [];
    for (let i = 0; i <= range.e.r; i++) {
      wsRows.push({ hpt: 40 });
    }
    ws['!rows'] = wsRows;

    // Apply cell styling
    for (let r = range.s.r; r <= range.e.r; r++) {
      for (let c = range.s.c; c <= range.e.c; c++) {
        const cellAddress = XLSX.utils.encode_cell({ r: r, c: c });
        if (!ws[cellAddress]) continue;

        // Default cell styling
        ws[cellAddress].s = {
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          font: { sz: 10 },
          border: {
            top: { style: 'thin', color: { rgb: '488dd1' } },
            bottom: { style: 'thin', color: { rgb: '488dd1' } },
            left: { style: 'thin', color: { rgb: '488dd1' } },
            right: { style: 'thin', color: { rgb: '488dd1' } }
          }
        };

        // Apply specific cell styling based on row and column indices
        if (r === 0 || r === 1) {
          // First two header rows: Blue background with white text
          ws[cellAddress].s.fill = { fgColor: { rgb: '112A5F' } };
          ws[cellAddress].s.font = { color: { rgb: 'FFFFFF' } };
        }
        else if (r === range.e.r) {
          ws[cellAddress].s.fill = { fgColor: { rgb: '112A5F' } };
          ws[cellAddress].s.font = { color: { rgb: 'FFFFFF' } };
        } else if (r === range.e.r - 1) {
          ws[cellAddress].s.fill = { fgColor: { rgb: '9d9fa1' } };
          ws[cellAddress].s.font = { color: { rgb: '000000' } };
        }

        // else if (r === range.e.r || r === range.e.r - 1) {
        //   // Last and second-last rows: Custom background with text color
        //   ws[cellAddress].s.fill = { fgColor: { rgb: '9D9FA1' } };
        //   ws[cellAddress].s.font = { color: { rgb: '000000' } };
        // }
        else if (c === 2) {
          // Column C: Pink background
          ws[cellAddress].s.fill = { fgColor: { rgb: 'FAD3D0' } };
        } else if (c === 13 && r > 0 && r < range.e.r - 1) {
          // Column N (excluding header, last row, second-last row): Green background
          ws[cellAddress].s.fill = { fgColor: { rgb: 'B6F4A7' } };
        } else {
          // Default cell styling for other cells
          ws[cellAddress].s.fill = { fgColor: { rgb: 'E7EBF4' } };
        }
      }
    }

    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Salary');

    // Save the workbook to a file with the specified file name
    XLSX.writeFile(wb, this.fileName);
  }

  //  munib
  getData(month: string, year: number, monthInt: number) {
    this.showSpinner = true;
    this.dashboardService.getAllUserSalariesMonthly(month, year, monthInt).then((value) => {
      this.usersList = value.data;
      this.totalSalary = 0
      this.totalDeduction = 0
      this.totalReleasedSalary = 0
      this.total_shourtHours = 0
      this.total_lateCheckin = 0
      this.total_unpaidLeaves = 0
      this.total__absents = 0
      this.total_Advance = 0
      this.total_Overtime = 0
      this.total_tax = 0
      this.loan_amount = 0
      this.total_otherDeduction = 0
      this.total_Compensation = 0
      this.usersList.forEach((user: any) => {
        if (user.user_salary?.length > 0) {
          this.totalSalary += parseFloat(user.user_salary[0].basic_salary)
          if (user.user_salary[0].total_deduction != null) {
            this.totalDeduction += parseFloat(user.user_salary[0].total_deduction)
          }
          if (user.user_salary[0].released_salary != null) {
            this.totalReleasedSalary += parseFloat(user.user_salary[0].released_salary)
          }

          if (user.user_salary[0].short_hours_amount != null) {
            this.total_shourtHours += parseFloat(user.user_salary[0].short_hours_amount)
          }

          if (user.user_salary[0].late_check_in_amount != null) {
            this.total_lateCheckin += parseFloat(user.user_salary[0].late_check_in_amount)
          }

          if (user.user_salary[0].unpaid_leaves_amount != null) {
            this.total_unpaidLeaves += parseFloat(user.user_salary[0].unpaid_leaves_amount)
          }


          if (user.user_salary[0].absents_amount != null) {
            this.total__absents += parseFloat(user.user_salary[0].absents_amount)
          }

          if (user.user_salary[0].advance_payment != null) {
            this.total_Advance += parseFloat(user.user_salary[0].advance_payment)
          }

          if (user.user_salary[0].overtime_amount != null) {
            this.total_Overtime += parseFloat(user.user_salary[0].overtime_amount)
          }

          if (user.user_salary[0].tax != null) {
            this.total_tax += parseFloat(user.user_salary[0].tax)
          }
          // Loan Amount munib
          if (user.user_salary[0].loan_deduction_amount != null) {
            this.loan_amount += parseFloat(user.user_salary[0].loan_deduction_amount)
          }
          if (user.user_salary[0].other_deduction != null) {
            this.total_otherDeduction += parseFloat(user.user_salary[0].other_deduction)
          }

          if (user.user_salary[0].compensation_amount != null) {
            this.total_Compensation += parseFloat(user.user_salary[0].compensation_amount)
          }
        }
      });
      this.showSpinner = false;
    });
  }
  SalaryCal() {
    this.router.navigate(['../salary-calculations']);
  }

  isSalaryNotAdded(user: any) {
    if (user.user_salary?.length == 0) {
      return true
    } else if (user.user_salary[0].released_salary == null) {
      return true
    }
    return false
  }
  isSalaryAddedd(user: any) {
    if (user.user_salary?.length > 0) {
      if (user.user_salary[0].released_salary != null) {
        return true
      }
      return false
    }
    return false
  }

  genrateNewSalary(user: any) {
    if (user.user_salary?.length > 0) {
      this.router.navigate(['/employee-payroll-salary-detail',
        {
          'user_id': user.id,
          'mont_char': this.month_char,
          'month_year': this.month_year,
          'mont_int': this.month_int,
          'salary_id': user.user_salary[0].id,
        }]);
    } else {
      this.showSpinner = true;
      this.dashboardService.assignNewSalary(
        user.id,
        this.month_char,
        this.month_year,
        this.month_int).then((value) => {
          this.showSpinner = false;
          if (value.success == true) {
            const id = value.data
            this.router.navigate(['/employee-payroll-salary-detail',
              {
                'user_id': user.id,
                'mont_char': this.month_char,
                'month_year': this.month_year,
                'mont_int': this.month_int,
                'salary_id': id,
              }]);
          } else {
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
              title: value.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
    }
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }



  getTotalDeduction(user: any) {
    return user?.user_salary?.[0]?.total_deduction ?? 0;
  }
  getShortHoursAmount(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.short_hours_amount;
      return val != null ? val : 0;
    }
    return 0;
  }
  getLateCheckInAmount(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.late_check_in_amount;
      return val != null ? val : 0;
    }
    return 0;
  }
  getUnpaidLeavesAmount(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const amount = salaryArr[0]?.unpaid_leaves_amount;
      return amount != null ? amount : 0;
    }
    return 0;
  }


  getAbsentsAmount(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.absents_amount;
      return val != null ? val : 0;
    }
    return 0;
  }

  getOvertimeAmount(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.overtime_amount;
      return val != null ? val : 0;
    }
    return 0;
  }


  getTax(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.tax;
      return val != null ? val : 0;
    }
    return 0;
  }



  getLoanDeduction(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.loan_deduction_amount;
      return val != null ? val : 0;
    }
    return 0;
  }

  getOtherDeduction(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.other_deduction;
      return val != null ? val : 0;
    }
    return 0;
  }

  getCompensationAmount(user: any) {
    const salaryArr = user?.user_salary;
    if (Array.isArray(salaryArr) && salaryArr.length > 0) {
      const val = salaryArr[0]?.compensation_amount;
      return val != null ? val : 0;
    }
    return 0;
  }










}
